import { useState } from 'react'
import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { useTheme } from '../theme'
import { avecAlpha } from '../lib/couleurs'

// Etape paiement carte (Stripe Payment Element) — montee avec le clientSecret du PaymentIntent
// renvoye par POST /client/orders. La carte ne transite jamais par notre serveur (PCI).

const VERT = 'rgb(var(--c-green))'
const ORANGE = 'rgb(var(--c-primary))'
const formatPrix = (n) => `${Number(n).toFixed(2).replace('.', ',')} €`

// loadStripe doit etre appele hors render et mis en cache par cle publiable.
const stripeCache = {}
const getStripe = (pk) => {
  if (!stripeCache[pk]) stripeCache[pk] = loadStripe(pk)
  return stripeCache[pk]
}

function PayForm({ amount, onSuccess, onBack }) {
  const { isWeb3 } = useTheme()
  const stripe = useStripe()
  const elements = useElements()
  const [submitting, setSubmitting] = useState(false)
  const [err, setErr] = useState('')

  const ts = 'text-ink/60'

  const submit = async (e) => {
    e.preventDefault()
    if (!stripe || !elements) return
    setSubmitting(true)
    setErr('')
    const { error } = await stripe.confirmPayment({ elements, redirect: 'if_required' })
    if (error) {
      setErr(error.message || 'Le paiement n’a pas pu aboutir.')
      setSubmitting(false)
      return
    }
    onSuccess()
  }

  return (
    <form onSubmit={submit}>
      <div className={`rounded-[20px] p-4 panneau-verre`}>
        <PaymentElement options={{ layout: 'tabs' }} />
      </div>
      {err && <p className="text-[12.5px] mt-2.5 font-semibold" style={{ color: '#d4503a' }}>{err}</p>}
      <button type="submit" disabled={!stripe || submitting}
        className="mt-4 w-full py-4 rounded-full text-[15px] font-extrabold disabled:opacity-60"
        style={{ background: ORANGE, color: VERT, boxShadow: `0 14px 32px ${avecAlpha(ORANGE, 0.33)}` }}>
        {submitting ? 'Paiement en cours…' : `Payer ${formatPrix(amount)}`}
      </button>
      <button type="button" onClick={onBack} disabled={submitting} className={`mt-2 w-full py-2 text-[13px] font-semibold ${ts}`}>
        Annuler
      </button>
    </form>
  )
}

export default function CheckoutPayment({ clientSecret, publishableKey, amount, onSuccess, onBack }) {
  const { isWeb3 } = useTheme()
  if (!publishableKey || !clientSecret) {
    return (
      <div className={`rounded-[20px] p-5 text-center panneau-verre`}>
        <p className="text-sm font-semibold" style={{ color: '#d4503a' }}>Paiement carte indisponible</p>
        <p className={`text-xs mt-1 text-ink/60`}>La configuration Stripe du portail est incomplète (clé publiable manquante). Réessaie plus tard.</p>
        <button onClick={onBack} className="mt-3 text-[13px] font-bold" style={{ color: ORANGE }}>‹ Retour</button>
      </div>
    )
  }
  return (
    <Elements stripe={getStripe(publishableKey)} options={{ clientSecret, appearance: { theme: 'flat', variables: { colorPrimary: ORANGE, colorText: VERT, borderRadius: '12px' } } }}>
      <PayForm amount={amount} onSuccess={onSuccess} onBack={onBack} />
    </Elements>
  )
}
